import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Irish translations (default)
const ga = {
  translation: {
    // App
    app: {
      name: 'Chlann',
      tagline: 'Do Theaghlach, Do Chomhrá',
    },

    // Welcome
    welcome: {
      subtitle: 'Fáilte go dtí Chlann',
      description: 'Ardán teachtaireachtaí do do theaghlach',
    },

    // Navigation
    nav: {
      chats: 'Comhráite',
      calls: 'Glaonna',
      calendar: 'Féilire',
      family: 'Clann',
      photos: 'Grianghraif',
      settings: 'Socruithe',
    },

    // Register page
    register: {
      createAccount: 'Cruthaigh do chuntas nua',
      passwordHint: '8 carachtar ar a laghad',
      haveAccount: 'Tá cuntas agat cheana?',
      signupCode: 'Cód Cláraithe',
      signupCodeHint: 'Faighte le hríomhphost cuiridh',
      elder: {
        enter: 'Cláraigh ceist ar cheist',
        stepCounter: 'Ceist {{current}} as {{total}}',
        nameQuestion: 'Cad is ainm duit?',
        emailQuestion: 'Cad é do sheoladh ríomhphoist?',
        phoneQuestion: 'Cad é d\'uimhir ghutháin?',
        passwordQuestion: 'Roghnaigh pasfhocal',
        codeQuestion: 'Cuir isteach do chód cuiridh',
      },
    },

    // Auth
    auth: {
      login: 'Logáil Isteach',
      register: 'Cláraigh',
      logout: 'Logáil Amach',
      email: 'Ríomhphost',
      phone: 'Uimhir Fóin',
      password: 'Pasfhocal',
      confirmPassword: 'Deimhnigh Pasfhocal',
      forgotPassword: 'Dearmad ar Phasfhocal?',
      twoFactor: 'Fíordheimhniú Dhá Chéim',
      enterCode: 'Cuir isteach an cód',
      sendCode: 'Seol Cód',
      verifyCode: 'Fíoraigh',
      inviteOnlyNotice: 'Tá Chlann ar cuireadh amháin le linn an triail-leagain. Iarr ar dhuine i do chlann atá ag úsáid Chlann cuireadh a sheoladh chugat, nó scríobh chugainn ag ',
      codeSentToEmail: 'Cuireadh cód chuig do ríomhphost',
      codeSentToPhone: 'Cuireadh cód chuig d\'fhón',
      registrationSuccess: 'Clárú Rathúil!',
      welcomeToFamily: 'Tá fáilte romhat sa teaghlach.',
      displayNamePlaceholder: 'Seán Ó Murchú',
      inviteCodePlaceholder: 'XXXX-XXXX-XXXX',
      inviteCodeHint: 'Cód cuiridh ó Macdara',
      inviteCodeFromLink: 'Cód faoi ghlas ón nasc cuiridh',
      privacyNote: 'Cláraigh ar an seansaol. Ní thugaimid do chlárúchán do Google, Microsoft, nó Apple.',
      privacyNoteLogin: 'Sínigh isteach ar an seansaol. Níl baint ar bith ag cuntas Google, Microsoft, nó Apple leis.',
      emailPlaceholder: 'ainm@sampla.ie',
      phonePlaceholder: '+353 ...',
      errors: {
        displayNameRequired: 'Ainm taispeána riachtanach',
        inviteCodeRequired: 'Tá cód cuiridh riachtanach',
        passwordTooShort: 'Caithfidh an pasfhocal a bheith 8 carachtar ar a laghad',
        passwordMismatch: 'Ní hionann na pasfhocail',
      },
    },

    // Chat
    chat: {
      newMessage: 'Teachtaireacht Nua',
      typeMessage: 'Clóscríobh teachtaireacht...',
      linkPreviewLoading: 'Ag lódáil réamhamharc',
      linkPreviewRemove: 'Bain an réamhamharc',
      send: 'Seol',
      sending: 'Ag seoladh...',
      sent: 'Seolta',
      delivered: 'Seachadta',
      read: 'Léite',
      failed: 'Theip ar sheoladh',
      typing: '{{name}} ag clóscríobh...',
      isTyping: 'ag clóscríobh',
      and: 'agus',
      areTyping: 'ag clóscríobh',
      severalPeopleTyping: 'Roinnt daoine ag clóscríobh',
      edited: 'curtha in eagar',
      deleted: 'Scriosadh an teachtaireacht seo',
      reply: 'Freagair',
      forward: 'Ar aghaidh',
      copy: 'Cóipeáil',
      delete: 'Scrios',
      deleteForEveryone: 'Scrios do gach duine',
      // New chat translations
      noMessages: 'Níl aon teachtaireachtaí ann fós',
      startConversation: 'Tosaigh an comhrá!',
      today: 'Inniu',
      yesterday: 'Inné',
      encryptedMessage: 'Seoladh an teachtaireacht seo sular athraigh Chlann an chaoi a gcoinnítear teachtaireachtaí. Fanann sí ar an ngléas a fuair í ar dtús amháin.',
      legacyRunCollapsed: 'Fanann {{n}} teachtaireacht níos luaithe ar an ngléas a fuair ar dtús iad.',
      notSent: 'Níor seoladh',
      notSentTapToRetry: 'Níor seoladh. Tapáil chun é a sheoladh arís.',
      textMessage: 'Teachtaireacht',
      attachFile: 'Ceangail comhad',
      // Irish input features
      irishPhrases: 'Frásaí Gaeilge',
      irishInputEnabled: 'Ionchur Gaeilge: a\' → á, Alt+a → á',
      fadaHelp: 'Clóscríobh guta + \' le haghaidh síne fada (m.sh. a\' → á) nó bain úsáid as Alt+guta',
      you: 'Tú',
      unknown: 'Anaithnid',
      group: 'Grúpa',
      noConversations: 'Níl aon chomhráite ann fós',
      startNew: 'Tosaigh Comhrá Nua',
      now: 'anois',
      members: 'ball',
      selectConversation: 'Roghnaigh comhrá',
      selectOrStart: 'Roghnaigh comhrá ón liosta, nó tosaigh ceann nua le do mhuintir',
      newConversation: 'Comhrá Nua',
      groupDetails: 'Sonraí an Ghrúpa',
      searchPeople: 'Cuardaigh daoine...',
      noUsers: 'Clóscríobh ainm chun baill teaghlaigh a aimsiú.',
      noUsersFound: 'Níor aimsíodh aon duine.',
      selectAtLeastOne: 'Roghnaigh duine amháin ar a laghad',
      groupName: 'Ainm an Ghrúpa',
      enterGroupName: 'Cuir isteach ainm an ghrúpa',
      createGroup: 'Cruthaigh Grúpa',
      startChat: 'Tosaigh Comhrá',
      createFailed: 'Theip ar an gcruthú',
      newGroup: 'Grúpa Nua',
      // W1-CHAT: bainistíocht liosta, admhálacha, frithghníomhartha, atriail
      pin: 'Pionnáil',
      unpin: 'Díphionnáil',
      pinned: 'Pionnáilte',
      mute: 'Balbhaigh',
      unmute: 'Díbhalbhaigh',
      muted: 'Balbhaithe',
      muteFor: 'Balbhaigh ar feadh',
      mute8h: '8 n-uaire',
      mute1d: '1 lá',
      mute7d: '1 seachtain',
      muteForever: 'Go deo',
      conversationOptions: 'Roghanna comhrá',
      moreReactions: 'Tuilleadh frithghníomhartha',
      reactions: 'Frithghníomhartha',
      whoReactedHint: 'Coinnigh síos le feiceáil cé a d\'fhreagair',
      someone: 'Duine éigin',
      seenBy: 'Feicthe ag',
      tapToRetry: 'Tapáil le hatriail',
      newMessages: 'Teachtaireachtaí nua',
      jumpToLatest: 'Léim go dtí an ceann is déanaí',
      messageType: {
        text: 'Teachtaireacht',
        image: 'Íomhá',
        video: 'Físeán',
        voice: 'Nóta Gutha',
        file: 'Comhad',
        location: 'Suíomh',
        poll: 'Pobalbhreith',
        system: 'Teachtaireacht Chórais',
      },
      // Search
      searchMessages: 'Cuardaigh teachtaireachtaí...',
      searchInConversation: 'Cuardaigh sa chomhrá seo...',
      searchHint: 'Cuir isteach ar a laghad 2 charachtar le cuardach',
      directMessage: 'Teachtaireacht dhíreach',
      pressEscToClose: 'Brúigh Esc le dúnadh',
      // Bot disclosure
      botLabel: 'Róbat',
      botNotEncrypted: 'Tá róbat sa chomhrá seo. Is féidir leis na teachtaireachtaí a sheolann tú anseo a léamh.',
      addBotConfirmTitle: 'Cuir róbat leis an gcomhrá?',
      addBotConfirmBody: 'Má chuireann tú {{botName}} leis, léifidh sé na teachtaireachtaí sa chomhrá seo. Ar aghaidh?',
      addBotContinue: 'Ar aghaidh',
      // UX refresh: labelled header actions + soft unread badge
      search: 'Cuardaigh',
      info: 'Eolas',
      unreadMessages: 'Teachtaireachtaí gan léamh',
      startNewDescription: 'Tosaigh do chéad chomhrá le do theaghlach',
    },

    // Calm presence buckets - never exact times
    presence: {
      activeNow: 'Ar líne',
      activeRecently: 'Gníomhach le déanaí',
      activeToday: 'Gníomhach inniu',
    },

    // Calls
    calls: {
      voice: 'Glao Gutha',
      video: 'Físghlao',
      incoming: 'Glao ag teacht isteach',
      incomingVoice: 'Glao gutha ag teacht isteach',
      incomingVideo: 'Físghlao ag teacht isteach',
      outgoing: 'Glao amach',
      missed: 'Glao caillte',
      ended: 'Críochnaíodh an glao',
      duration: 'Fad: {{duration}}',
      mute: 'Balbhaigh',
      unmute: 'Díbhalbhaigh',
      camera: 'Ceamara',
      cameraOn: 'Las an ceamara',
      cameraOff: 'Múch an ceamara',
      videoOff: 'As',
      speaker: 'Callaire',
      speakerOn: 'Las an callaire',
      speakerOff: 'Múch an callaire',
      endCall: 'Críochnaigh Glao',
      noHistory: 'Níl aon ghlaonna fós',
      startFirst: 'Glaonna gutha agus físeáin idir do theaghlach. Oscail comhrá chun tús a chur le ceann.',
      startCallCTA: 'Oscail Comhrá',
      accept: 'Glac',
      decline: 'Diúltaigh',
      calling: 'Ag glaoch...',
      initiating: 'Ag tionscnamh...',
      ringing: 'Ag bualadh...',
      connecting: 'Ag nascadh...',
      callEnded: 'Críochnaíodh an glao',
      speaking: 'Ag labhairt',
      flipCamera: 'Athraigh ceamara',
      // Iontráil glao nua + roghnóir teagmhálaithe
      newCall: 'Glao nua',
      searchContacts: 'Cuardaigh teagmhálacha...',
      noSearchResults: 'Níor aimsíodh aon teagmhálaí',
      noConversations: 'Níl aon chomhrá ann fós',
      startChatFirst: 'Cuir tús le comhrá ar dtús chun glaonna a dhéanamh',
      voiceCall: 'Glao gutha',
      videoCall: 'Físghlao',
      selectContact: 'Roghnaigh teagmhálaí chun glao gutha nó físghlao a thosú',
      memberCount: '{{count}} ball',
      // Earráidí tosaithe glao
      errorMicBlocked: 'Níorbh fhéidir le chlann do mhicreafón a rochtain - seiceáil ceadanna an tsuímh i do bhrabhsálaí.',
      errorNoMic: 'Níor aimsíodh aon mhicreafón. Ceangail ceann agus bain triail eile as.',
      errorMicInUse: 'Tá do mhicreafón in úsáid ag aip eile. Dún í agus bain triail eile as.',
      errorGeneric: 'Níorbh fhéidir an glao a thosú. Bain triail eile as.',
      // Táscaire an naisc
      connectionQuality: 'Cáilíocht an naisc',
      reconnecting: 'Ag athnascadh...',
      connectionRestored: 'Nasc athbhunaithe',
      connectionLost: 'Cailleadh an nasc',
      // Comhrialú sa ghlao + cárta glao caillte
      participantMuted: 'Tá {{name}} balbhaithe',
      callBack: 'Glaoigh ar ais',
      cardMissed: 'Glao caillte',
      cardDeclined: 'Níor freagraíodh an glao',
      cardMessage: 'Teachtaireacht',
      missedCallReply: 'Tá brón orm gur chaill mé do ghlao - labhróimid go luath.',
      // Labelled call controls (visible word under each circle)
      end: 'Críochnaigh',
      flip: 'Athraigh',
      blur: 'Doiléirigh',
      reactLabel: 'Frithghníomh',
      react: 'Seol frithghníomh',
    },

    // Family
    family: {
      create: 'Cruthaigh Teaghlach',
      join: 'Bí páirteach i dTeaghlach',
      invite: 'Tabhair Cuireadh',
      members: 'Baill',
      admin: 'Riarthóir',
      member: 'Ball',
      guest: 'Aoi',
      leave: 'Fág',
      inviteCode: 'Cód Cuiridh',
      noFamilies: 'Níl aon teaghlach fós',
      createFirst: 'Cruthaigh ceann do do theaghlach díreach',
      orJoin: 'nó ceangail le ceann atá ann le cód cuiridh ó bhall',
      emptyHint: 'Is féidir an dá rud a dhéanamh - an grúpa Uí Mhurchú agus an grúpa Mac Cárthaigh, mar shampla.',
      familyName: 'Ainm an Teaghlaigh',
      enterFamilyName: 'Cuir isteach ainm an teaghlaigh',
      description: 'Cur Síos',
      enterDescription: 'Cuir síos (roghnach)',
      creating: 'Ag cruthú...',
      joining: 'Ag dul isteach...',
      enterInviteCode: 'Cuir isteach cód cuiridh',
      regenerateCode: 'Athghintear Cód',
      copyCode: 'Cóipeáil Cód',
      codeCopied: 'Cód cóipeáilte!',
      removeMember: 'Bain Ball',
      promoteTo: 'Ardaigh go',
      demoteTo: 'Ísligí go',
      confirmLeave: 'An bhfuil tú cinnte gur mhaith leat an teaghlach seo a fhágáil?',
      confirmRemove: 'An bhfuil tú cinnte gur mhaith leat {{name}} a bhaint?',
      lastAdminWarning: 'Ní féidir leat an teaghlach a fhágáil mar an riarthóir deireanach.',
      youAre: 'Is',
      you: 'tú',
      memberSince: 'Ball ó',
      conversations: 'Comhráite',
      selectFamily: 'Roghnaigh do theaghlach.',
      inviteFamily: 'Tabhair cuireadh don teaghlach',
      inviteIntro: 'Roinn an nasc seo nó an cód QR le do mhuintir le go mbeidh siad in ann teacht isteach in aon tapáil amháin.',
      inviteLink: 'Nasc cuiridh',
      copyLink: 'Cóipeáil nasc',
      linkCopied: 'Nasc cóipeáilte!',
      shareInvite: 'Roinn',
      showQr: 'Taispeáin cód QR',
      hideQr: 'Folaigh cód QR',
      scanToJoin: 'Scan chun teacht isteach',
      inviteShareText: 'Bí páirteach i {{family}} ar Chlann',
    },

    // Photos
    photos: {
      gallery: 'Gailearaí',
      albums: 'Albam',
      allPhotos: 'Gach Grianghraf',
      upload: 'Uaslódáil',
      search: 'Cuardaigh grianghraif...',
      people: 'Daoine',
      places: 'Áiteanna',
      noPhotos: 'Pictiúir teaghlaigh idir libh',
      uploadFirst: 'Tapáil + chun do chéad ghrianghraf teaghlaigh a roinnt. Fanann gach rud a roinneann tú príobháideach do do theaghlach.',
      uploadFirstCTA: 'Uaslódáil Pictiúir',
      noAlbums: 'Níl aon albam fós',
      createAlbumFirst: 'Eagraigh pictiúir i mbailiúcháin do bhreithlaethe, laethanta saoire, agus eile.',
      createAlbumCTA: 'Cruthaigh Albam',
      newAlbum: 'Albam Nua',
      createAlbum: 'Cruthaigh Albam',
      albumName: 'Ainm an Albaim',
      albumNamePlaceholder: 'Cuir isteach ainm an albaim',
      renameAlbum: 'Athainmnigh albam',
      deleteAlbum: 'Scrios albam',
      albumActions: 'Gníomhartha albaim',
      deleteAlbumTitle: 'Scrios Albam',
      deleteAlbumMessage: 'Scrios an t-albam seo? Ní scriostar na grianghraif féin.',
      description: 'Cur Síos',
      descriptionPlaceholder: 'Cur síos roghnach...',
      dropOrClick: 'Tarraing grianghraif anseo nó cliceáil le roghnú',
      selectedCount: '{{count}} grianghraf roghnaithe',
      loadMore: 'Lódáil níos mó',
      select: 'Roghnaigh',
      selectionCount: '{{count}} roghnaithe',
      simpleMode: 'Amharc simplí',
      pin: 'Greamaigh',
      unpin: 'Díghreamaigh',
      pinned: 'Greamaithe',
      hide: 'Folaigh',
      moveUp: 'Bog suas',
      moveDown: 'Bog síos',
      openPhoto: 'Oscail grianghraf ó {{date}}',
      allHidden: 'Tá gach grianghraf folaithe',
      allHiddenDesc: 'Tá gach grianghraf san amharc seo folaithe agat.',
      showHidden: 'Taispeáin grianghraif fholaithe',
      showHiddenCount: 'Taispeáin {{count}} folaithe',
      addToAlbum: 'Cuir le halbam',
      chooseAlbum: 'Roghnaigh albam',
      noAlbumsToAdd: 'Cruthaigh albam ar dtús chun grianghraif a chur leis.',
      download: 'Íoslódáil',
      setAsCover: 'Socraigh mar chlúdach',
      showAllPhotos: 'Taispeáin gach grianghraf',
      deletePhotosTitle: 'Scrios Grianghraif',
      deletePhotosMessage_one: 'Scrios an grianghraf seo? Ní féidir é seo a chealú.',
      deletePhotosMessage_other: 'Scrios {{count}} grianghraf? Ní féidir é seo a chealú.',
      searchComingSoon: 'Tiocfaidh cuardach grianghraf tar éis an tseolta.',
      searchComingSoonBody: 'Le haghaidh v1 is féidir leat brabhsáil de réir albaim. Tá cuardach séimeantach agus grúpáil aghaidheanna ar an treochlár iar-sheolta.',
      video: 'Físeán',
      regenerateRecap: 'Taispeáin cuimhne eile',
      hideRecap: 'Folaigh ar an lá seo',
      period: {
        today: 'Inniu',
        yesterday: 'Inné',
        thisWeek: 'Níos luaithe an tseachtain seo',
        thisMonth: 'Níos luaithe an mhí seo',
      },
    },

    // Memory Session (shared slideshow during calls)
    memory: {
      sharePhotos: 'Roinn Grianghraif',
      selectAlbum: 'Roinn Grianghraif',
      selectAlbumDescription: 'Roghnaigh albam le féachaint le chéile',
      noAlbums: 'Níl Aon Albam Ann',
      noAlbumsDescription: 'Cruthaigh albam ar dtús chun grianghraif a roinnt le linn glaonna',
      photoCount: '{{count}} grianghraf',
      playRecap: 'Seinn an cnuasach',
      playRecapDescription: 'Féach siar ar gach rud atá roinnte agaibh',
      emptyAlbum: 'Níl aon ghrianghraf san albam seo go fóill. Cuir cúpla grianghraf leis, ansin bain triail eile as.',
      emptyRecap: 'Níl aon ghrianghraif roinnte le cnuasach a dhéanamh go fóill. Roinn roinnt grianghraf sa chomhrá seo, ansin bain triail eile as.',
      emptyDate: 'Níor roinneadh aon ghrianghraif ar an lá seo i mblianta roimhe seo go fóill.',
      emptySelection: 'Níorbh fhéidir aon cheann de na grianghraif a roghnaíodh a thaispeáint.',
      bothCanControl: 'Is féidir leis an mbeirt rannpháirtithe an taispeántas sleamhnán a rialú',
      noPhotos: 'Níl aon ghrianghraif',
      previous: 'Grianghraf roimhe',
      next: 'An chéad ghrianghraf eile',
      play: 'Tosaigh taispeántas sleamhnán',
      pause: 'Cuir sos ar thaispeántas sleamhnán',
      endSession: 'Críochnaigh seisiún cuimhne',
      photo: 'Grianghraf',
      photoLoadError: 'Níorbh fhéidir an grianghraf a lódáil',
      previousPhoto: 'An grianghraf roimhe',
      nextPhoto: 'An chéad ghrianghraf eile',
      sitBackAndEnjoy: 'Suigh Siar & Bain Taitneamh As',
      autoPlayHint: 'Seinnfear na grianghraif go huathoibríoch',
      onThisDay: 'Ar an lá seo',
      tapToLookTogether: 'Tapáil cuimhne le féachaint siar le chéile',
      lookTogether: 'Féach siar le chéile',
      dailyPromptTitle: 'Ar an lá seo',
      dailyPromptBody: 'Roinn do theaghlach móimintí ar an lá seo.',
      dailyPromptBodyNamed: 'Roinn tú féin agus {{name}} móimintí ar an lá seo.',
      notNow: 'Níl anois',
    },

    // Calendar
    calendar: {
      title: 'Féilire',
      newEvent: 'Imeacht Nua',
      editEvent: 'Cuir Imeacht in Eagar',
      create: 'Cruthaigh',
      noEvents: 'Níl aon imeachtaí ann don lá seo',
      noEventsHint: 'Tapáil + Imeacht Nua chun breithlá, teacht le chéile, nó meabhrúchán a chur leis.',
      today: 'Inniu',
      allDay: 'An lá ar fad',
      location: 'Suíomh',
      locationPlaceholder: 'Cuir suíomh leis...',
      description: 'Cur Síos',
      descriptionPlaceholder: 'Cuir cur síos leis...',
      titlePlaceholder: 'Ainm an imeachta',
      startDate: 'Dáta Tosaithe',
      startTime: 'Am Tosaithe',
      endDate: 'Dáta Deiridh',
      endTime: 'Am Deiridh',
      color: 'Dath',
      reminder: 'Meabhrúchán',
      reminderNone: 'Gan meabhrúchán',
      reminderMinutes: '{{count}} nóiméad roimhe',
      reminderHours: '{{count}} uair roimhe',
      reminderDays: '{{count}} lá roimhe',
      recurrence: {
        label: 'Athfhilleadh',
        none: 'Gan athfhilleadh',
        daily: 'Gach lá',
        weekly: 'Gach seachtain',
        monthly: 'Gach mí',
        yearly: 'Gach bliain',
        endDate: 'Dáta deiridh athfhillte',
      },
      rsvp: {
        accept: 'Glac',
        decline: 'Diúltaigh',
        maybe: 'B\'fhéidir',
      },
      yourRsvp: 'Do RSVP',
      attendee: 'freastalaí',
      attendees: 'freastalaithe',
      createdBy: 'Cruthaithe ag {{name}}',
      deleteConfirmTitle: 'Scrios Imeacht',
      deleteConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat an t-imeacht seo a scriosadh? Ní féidir é seo a chealú.',
      days: {
        mon: 'Lua',
        tue: 'Mái',
        wed: 'Céa',
        thu: 'Déa',
        fri: 'Aoi',
        sat: 'Sat',
        sun: 'Dom',
      },
      months: {
        january: 'Eanáir',
        february: 'Feabhra',
        march: 'Márta',
        april: 'Aibreán',
        may: 'Bealtaine',
        june: 'Meitheamh',
        july: 'Iúil',
        august: 'Lúnasa',
        september: 'Meán Fómhair',
        october: 'Deireadh Fómhair',
        november: 'Samhain',
        december: 'Nollaig',
      },
    },

    // Welcome Wizard
    wizard: {
      welcome: {
        title: 'Fáilte go Chlann',
        subtitle: 'Ardán teachtaireachtaí príobháideach do do theaghlach. Criptithe, slán, agus tógtha duit.',
        getStarted: 'Tosaigh',
        featureChat: 'Teachtaireachtaí',
        featurePhotos: 'Grianghraif',
        featureCalls: 'Glaonna',
        featurePrivacy: 'Teachtaireachtaí criptithe',
      },
      family: {
        title: 'Socraigh do Theaghlach',
        subtitle: 'Cruthaigh teaghlach nua nó bí páirteach le cód cuiridh.',
        createNew: 'Cruthaigh Teaghlach',
        createDesc: 'Tosaigh grúpa nua do do theaghlach',
        joinExisting: 'Bí Páirteach i dTeaghlach',
        joinDesc: 'Cuir cód cuiridh isteach ó bhall teaghlaigh',
        familyName: 'Ainm an Teaghlaigh',
        familyNamePlaceholder: "m.sh. Teaghlach Uí Shé",
        inviteCode: 'Cód Cuiridh',
        inviteCodePlaceholder: 'Cuir isteach cód cuiridh',
        skip: 'Déan é seo níos déanaí',
      },
      comfort: {
        title: 'Déan an téacs níos mó?',
        subtitle: 'Méadaíonn Mód Compoird an téacs agus na cnaipí ionas go bhfuil Chlann níos éasca le léamh agus le brú. Is féidir é a athrú am ar bith sna Socruithe.',
        sample: 'Seo mar a bheidh do chuid téacs.',
        enable: 'Cuir Mód Compoird ar siúl',
        keepStandard: 'Coinnigh an gnáthmhéid',
      },
      complete: {
        title: 'Tá tú réidh!',
        subtitleWithFamily: 'Tá do theaghlach socraithe. Tosaigh ag comhrá!',
        subtitleWithoutFamily: 'Is féidir leat teaghlach a chruthú nó a cheangal am ar bith ó na Socruithe.',
        startChatting: 'Tosaigh ag Comhrá',
      },
      progress: {
        step: 'Céim {{current}} de {{total}}',
      },
    },

    // Settings
    settings: {
      profile: 'Proifil',
      displayName: 'Ainm Taispeana',
      privacy: 'Priobhaideacht',
      notifications: 'Fograí',
      deviceListCapNote: 'Ag taispeáint na ngléas is deireanaí a bhí gníomhach ({{shown}} as {{total}})',
      deviceSecurityInfo: 'Nuair a bhaintear gléas, logáiltear amach é agus cúlghairtear a rochtain ar do chuntas. Fanann stair do theachtaireachtaí slán agus inléite ar do ghléasanna eile.',
      language: 'Teanga',
      theme: 'Teama',
      darkMode: 'Mod Dorcha',
      darkModeDesc: 'Cuma níos dorcha, níos boige ar na súile san oíche',
      appearance: 'Cuma',
      themeSystem: 'Córas',
      themeLight: 'Geal',
      themeDark: 'Dorcha',
      accessibility: 'Inrochtaineacht',
      accessibilityMode: 'Mod Inrochtaineachta',
      about: 'Faoi',
      version: 'Leagan',
      display: 'Taispeáint',
      textSize: 'Méid an téacs',
      textSizeDesc: 'Déan an téacs ar fad níos mó nó níos lú',
      textSizeStandard: 'Caighdeánach',
      textSizeLarge: 'Mór',
      textSizeLarger: 'Níos mó',
      highContrast: 'Codarsnacht ard',
      highContrastDesc: 'Téacs agus imill níos láidre le léamh níos éasca',
      dyslexiaFont: 'Cló soléite',
      dyslexiaFontDesc: 'Cruth litreacha níos éasca le léamh do dhisléicse',
      fullscreen: 'Mód Lánscáileáin',
      fullscreenDesc: 'Folaigh barra stádais an ghléis le tumadh iomlán',
      fullscreenNotSupported: 'Ní thacaíonn do bhrabhsálaí le mód lánscáileáin',
      changePhoto: 'Athraigh Grianghraf',
      removePhoto: 'Bain Grianghraf',
      uploadAvatar: 'Uaslódáil Grianghraf Próifíle',
      invalidImageType: 'Cineál íomhá neamhbhailí. Úsáid JPEG, PNG, GIF, nó WebP.',
      imageTooLarge: 'Tá an íomhá ró-mhór. Is í 5MB an teorainn.',
      comfort: 'Déan chlann níos éasca le feiceáil',
      comfortDesc: 'Méid an téacs, codarsnacht agus gluaiseacht. Bíonn siad seo i bhfeidhm i ngach áit i chlann agus saor in aisce i gcónaí.',
      textSizeUseSystem: 'Úsáid méid téacs an chórais',
      textSizeUseSystemDesc: 'Lean an méid téacs atá socraithe ar do ghléas',
      reduceMotion: 'Laghdaigh gluaiseacht',
      reduceMotionDesc: 'Níos lú beochana agus gluaiseachta',
      reset: 'Athshocraigh',
      previewLabel: 'Réamhamharc',
      previewHeading: 'Comhrá teaghlaigh',
      previewMessage1: 'An bhfuil tú ag teacht chun dinnéir Dé Domhnaigh?',
      previewMessage2: 'Beimid ann. An féidir linn rud éigin a thabhairt?',
      previewHint: 'Bog an sleamhnán chun méid do théacs a shocrú. Athraíonn sé an téacs i ngach áit i chlann.',
      // Instant-apply settings: scoped Save + saved/failed feedback
      saveProfile: 'Sábháil an phróifíl',
      changesSaved: 'Sábháilte',
      saveFailed: 'Níorbh fhéidir an t-athrú sin a shábháil. Bain triail eile as.',
    },

    // Privacy
    privacy: {
      onlineStatus: 'Taispeáin stádas ar líne',
      lastSeen: 'Taispeáin "feicthe go deireanach"',
      readReceipts: 'Seol admhálacha léite',
      typingIndicator: 'Taispeáin táscaire clóscríofa',
    },

    // Notifications
    notifications: {
      title: 'Fógraí',
      enablePush: 'Cumasaigh fógraí brúigh',
      enableInApp: 'Cumasaigh fógraí san aip',
      muteAll: 'Balbhaigh gach fógra',
      notifyFor: 'Fógair dom faoi:',
      messages: 'Teachtaireachtaí',
      calls: 'Glaonna',
      familyUpdates: 'Nuashonruithe teaghlaigh',
      photoUploads: 'Uaslódálacha grianghraf',
      markAllRead: 'Marcáil gach ceann mar léite',
      noNotifications: 'Níl aon fhógraí agat',
      viewAll: 'Féach ar gach ceann',
      newMessage: 'Teachtaireacht nua ó {{sender}}',
      incomingCall: 'Glao ag teacht isteach ó {{caller}}',
      familyJoined: 'Chuaigh {{member}} isteach sa teaghlach',
      newPhotos: 'D\'uaslódáil {{uploader}} grianghraif nua',
      deleteConfirm: 'An bhfuil tú cinnte go dteastaíonn uait an fógra seo a scriosadh?',
      delete: 'Scrios fógra',
      empty: 'Níl aon fhógraí agat',
      settings: 'Socruithe fógra',
    },

    // Common
    common: {
      save: 'Sábháil',
      saving: 'Ag sábháil...',
      cancel: 'Cealaigh',
      done: 'Déanta',
      edit: 'Cuir in Eagar',
      delete: 'Scrios',
      create: 'Cruthaigh',
      close: 'Dún',
      confirm: 'Deimhnigh',
      loading: 'Ag Lódáil...',
      error: 'Earráid',
      success: 'Rath',
      retry: 'Bain triail eile as',
      yes: 'Tá',
      no: 'Níl',
      ok: 'OK',
      or: 'no',
      back: 'Ar ais',
      next: 'Ar aghaidh',
      search: 'Cuardaigh',
      noResults: 'Níor aimsíodh aon torthaí',
      menu: 'Roghchlár',
    },

    // Time
    time: {
      justNow: 'díreach anois',
      minuteAgo: 'nóiméad ó shin',
      minutesAgo: '{{count}} nóiméad ó shin',
      hourAgo: 'uair an chloig ó shin',
      hoursAgo: '{{count}} uair an chloig ó shin',
      yesterday: 'inné',
      daysAgo: '{{count}} lá ó shin',
    },

    // Landing Page (marketing rebuild - phase 4b)
    landing: {
      nav: {
        privacy: 'Príobháideacht',
        app: 'An táirge',
        invites: 'Cuirí',
        pricing: 'Praghsanna',
        requestInvite: 'Iarr cuireadh',
        comfort: 'Compord',
      },
      hero: {
        h1En: 'A private room for the whole family.',
        h1Ga: 'Seomra príobháideach don chlann go léir.',
        primary: 'Iarr cuireadh',
        proof: {
          encrypted: 'Teachtaireachtaí príobháideacha, criptithe',
          noAds: 'Gan fógraí, gan rianú tríú páirtí',
          allGenerations: 'Le haghaidh gach glúine',
        },
        imageAlt: 'Trí ghlúin timpeall bhord na cistine, tae á dhoirteadh, fón ina luí eatarthu ar an mbord.',
      },
      thread: {
        title: 'An Teaghlach',
        sub: '9 duine · ar líne',
        encrypted: 'Criptithe',
        momName: 'Máire (Mam)',
        momMsg: 'Dinnéar ag a 7 ar an Domhnach. Tá Nana ag tabhairt an toirtín úll.',
        myReply: 'Togha, beidh mé ann.',
        nanaName: 'Nana',
        voiceDuration: '0:42',
        previewLabel: 'Réamhamharc snáithe',
      },
      privacy: {
        eyebrow: 'Príobháideacht',
        h2: 'Tá do theachtaireachtaí criptithe agus iad á seoladh agus i dtaisce ar fhreastalaithe a oibrímid san Astráil. Ní dhíoltar agus ní scanntar riamh iad le haghaidh fógraí.',
        intro: 'Seo go díreach a bhfuil cosanta, agus a fheicimid agus nach bhfeicimid, i dtéarmaí soiléire. Gan siombailí glas, gan margaíocht.',
        claim1: {
          title: 'Criptithe agus á seoladh agus ar an bhfreastalaí',
          body: 'Téann teachtaireachtaí thar TLS agus stóráiltear criptithe iad ar fhreastalaithe a oibrímid san Astráil. Ní bhíonn fógraí, rianú tríú páirtí ná scanadh ábhair againn. Ní féidir linn ábhar teachtaireachta a rochtain ach nuair a éilíonn an dlí é, nó chun gníomhú ar thuairisc inchreidte um shábháilteacht leanaí.',
          step1: 'Criptithe agus á seoladh (TLS) agus ar ár bhfreastalaí',
          step2: 'Gan fógraí, gan rianú tríú páirtí, gan scanadh ábhair',
          step3: 'Rochtain ach le hordú dlí bailí nó tuairisc um shábháilteacht leanaí',
        },
        claim2: {
          title: 'Ardchaighdeán ó dhúchas',
          body: 'Pictiúir ag caighdeán níos airde ná mar a choinníonn WhatsApp nó Messenger iad.',
          step1: 'Pictiúir: Bunaidh / Caighdeán / Tapa - do rogha féin',
          step3: 'An rud a sheolann tú, sin a choinnímid',
        },
        claim3: {
          title: 'Gan fógraí, gan rianú',
          body: 'Níl fógraí againn. Níl anailísíocht tríú páirtí againn. Ní scanaimid do theachtaireachtaí agus ní dhíolaimid do chuid sonraí. Íocann tú síntiús beag linn, nó ní íocann. Sin an múnla gnó ar fad.',
          step1: 'Sraith saor flaithiúil: 1 GB de chuimhní teaghlaigh',
          step2: 'Pleananna íoctha ó €4/mí',
          step3: 'Gan sraith ina bhfuil úsáideoirí mar tháirge',
        },
        cipher: {
          heading: 'Taispeáin, ná habair',
          serverLabel: 'Stóráilte ar ár bhfreastalaithe',
          deviceLabel: 'Seachadta sa seomra teaghlaigh',
          message: 'Oíche mhaith, a Nana ❤️',
          note: 'Stóráilte criptithe ar ár bhfreastalaithe. Tá an méid a fheicimid agus nach bhfeicimid leagtha amach thíos.',
        },
      },
      product: {
        h2: 'Teachtaireachtaí, féilire, pictiúir. Seomra amháin don chlann.',
        thread: {
          title: 'Comhrá an teaghlaigh',
          body: 'Teachtaireachtaí grúpa, freagraí, nótaí gutha, frithghníomhartha. Gach duine ar an snáithe céanna.',
          msg1Name: 'Nana',
          msg1: 'Conas atá sibh?',
          msg2: 'Go maith a Nana!',
        },
        calendar: {
          title: 'Féilire roinnte',
          body: 'RSVPanna, meabhrúcháin in aghaidh an duine, tuairimí i gcomhthéacs. Gan cóipeáil ó ríomhphost.',
          monthLabel: 'Iúil',
          year: '2026',
          event1Month: 'IÚIL',
          event1Title: 'Baisteadh Cillian',
          event1Chip: 'Ag dul 14',
          event2Month: 'MÁRT',
          event2Title: 'Lá fhéile Pádraig',
          event2Chip: 'Feitheamh 3',
          event3Month: 'SAMH',
          event3Title: 'Breithlá Dhaid',
          event3Chip: 'Meabhrú',
          alt: 'Táibléad ar chuntar na cistine ag taispeáint fhéilire an teaghlaigh agus an mhaidin ag imeacht thart air.',
        },
        photos: {
          title: 'Pictiúir an teaghlaigh',
          body: 'Albaim de réir míosa nó d\'imeachta.',
          nanaLabel: 'Nana',
          alt: 'Móraí agus a garmhuirín ag breathnú ar phictiúir an teaghlaigh ar fhón.',
        },
        groupCall: {
          title: 'An chlann ar fad',
          body: 'Trí ghlúin, ceithre theach, glao amháin. Gan socrú, gan dáta a shocrú roimh ré - oíche Aoine ag a sé.',
          alt: 'Thar ghualainn Mhóraí: táibléad ar bhord na cistine ag taispeáint glao físe ceithre-thaobhach lena clann.',
        },
        splitCall: {
          title: 'Aghaidh ar aghaidh',
          body: "Cuir glao ar Mhóraí. Cuir glao ar do mháthair. Gan dáta a shocrú, gan ceamara a ullmhú - díreach 'haigh, conas atá tú?' as Gaeilge nó as Béarla.",
          alt: 'Glao físe scoilte idir bean óg agus a seanathair.',
        },
      },
      comfort: {
        eyebrow: "Do Nana agus do d'iníon",
        h2: 'An cómhéadan céanna, dhá dhlús.',
        intro: 'Is gné táirge é Modh Compoirt, ní socrú folaithe. Spriocanna níos mó, téacs níos mó, ní bhaintear rud ar bith amach. Úsáideann seantuismitheoir agus déagóir an aip chéanna.',
        standardTag: 'Gnáth · spriocanna 40px',
        comfortTag: 'Modh Compoirt · spriocanna 56px',
        cardTitle: 'Teachtaireacht nua ó Mháire',
        cardBody: 'Dinnéar ag a 7 ar an Domhnach. Tá Nana ag tabhairt an toirtín.',
        reply: 'Freagair',
        later: 'Déanach',
        toggleOn: 'Cuir Modh Compoirt ar siúl',
        toggleOff: 'Múch Modh Compoirt',
      },
      invite: {
        eyebrow: 'Ar cuireadh amháin, d\'aon ghnó',
        h2: 'Gan clárú poiblí. Téann tú isteach i gclann, ní i líonra.',
        intro: "Roinneann duine i do chlann nasc cuiridh nó cód QR amháin leat - tapáil é agus tá tú istigh. Ní bhailítear uimhir ghutháin, ní léitear leabhar seoltaí, gan aimsitheacht.",
        testingFootnote: 'Le linn na tástála dúnta, eisíonn Chlann na cóid go díreach in ionad bhaill teaghlaigh eile. Téigh ar an liosta feithimh chun ceann a iarraidh.',
        step1: {
          title: 'Faigh do nasc',
          body: 'Cruthaíonn ball den teaghlach nasc cuiridh agus cód QR ón leathanach Clann.',
        },
        step2: {
          title: 'Roinn é',
          body: 'Tapáil Roinn chun é a chur isteach sa ghrúpa WhatsApp atá agaibh cheana, nó taispeáin an cód QR le scanadh.',
        },
        step3: {
          title: 'Tapáil le teacht isteach',
          body: 'Osclaíonn an nasc Chlann agus líonann sé an cód duit. Gan aon chód le clóscríobh de láimh.',
        },
        step4: {
          title: 'Tairg Modh Compoirt',
          body: "Fiafraíonn an app díot sa chéad úsáid. Ní shocraíonn tú é ar son duine ar bith eile - roghnaíonn gach duine.",
        },
      },
      pricing: {
        eyebrow: 'Praghsanna',
        h2: 'Pleananna a fhásann le do chlann.',
        intro: 'Sraith saor flaithiúil. Pleananna íoctha ag tosú ó €4/mí. Aon phlean amháin in aghaidh an teaghlaigh - níl uimhir teorann ar bhaill an teaghlaigh.',
        testingNotice: 'Na praghsanna a thaispeántar do thréimhse tar éis na tástála dúnta. Tá tástálaithe béite saor in aisce.',
        toggle: {
          monthly: 'Sa mhí',
          annual: 'Sa bhliain',
          saveLabel: 'sábháil 2 mhí',
        },
        popular: 'Is fearr leo seo',
        perMonth: '/mí',
        perYear: '/bhliain',
        ctaFree: 'Tosaigh saor in aisce',
        ctaPaid: 'Roghnaigh',
        free: 'Saor in aisce',
        tiers: {
          caint: {
            name: 'Caint',
            sub: 'Saor',
            tagline: 'Seomra teaghlaigh saor in aisce.',
            storage: '1 GB',
            f1: 'Comhrá, féilire, pictiúir, glaonna',
            f2: 'Glaonna grúpa go dtí ceathrar',
            f3: 'Tacaíocht ríomhphost - 1 sheachtain oibre',
          },
          cuairt: {
            name: 'Cuairt',
            sub: 'Lite',
            tagline: 'Bliain de chuimhní teaghlaigh.',
            storage: '25 GB',
            f1: 'Rogha cáilíochta pictiúir: Bunaidh / Caighdeán / Tapa',
            f2: 'Albaim roinnte, de réir míosa nó imeachta',
            f3: 'Tacaíocht ríomhphost - 1 lá oibre',
          },
          teach: {
            name: 'Teach',
            sub: 'Family',
            tagline: 'Baile don teaghlach iomlán.',
            storage: '100 GB',
            f1: 'Gach gné de Chuairt',
            f2: 'Stóráil do bhlianta de shaol digiteach an teaghlaigh',
            f3: 'Tacaíocht ríomhphost - 1 lá oibre',
          },
          duchas: {
            name: 'Dúchas',
            sub: 'Heritage',
            tagline: 'Glúnta de chuimhní teaghlaigh.',
            storage: '500 GB',
            f1: 'Gach gné de Theach',
            f2: 'Tógtha chun gach Nollaig, gach lá breithe a choinneáil',
            f3: 'Tacaíocht thosaíochta - 1 lá oibre',
          },
          cartlann: {
            name: 'Cartlann',
            sub: 'Archive',
            tagline: 'Gach pictiúr, gach físeán, gach nóta gutha.',
            storage: '1 TB',
            f1: 'Gach gné de Dhúchas',
            f2: 'Don ghrianghrafadóir, don staraí, don scéalaí',
          },
        },
      },
      closedTesting: {
        banner: 'Tá Chlann i dtástáil dúnta faoi láthair. Téigh ar an liosta feithimh chun cuireadh a fháil.',
        dismiss: 'Dún an fógra',
      },
      waitlist: {
        title: 'Téigh ar an liosta feithimh',
        intro: 'Inis dúinn beagán faoi do chlann. Seolfaimid cód chugat chomh luath agus a bhíonn slot againn.',
        emailLabel: 'Ríomhphost',
        emailPlaceholder: 'tu@example.com',
        nameLabel: 'Do ainm',
        namePlaceholder: 'Máire Ní Bhriain',
        familyContextLabel: 'Inis dúinn faoi do chlann (roghnach)',
        familyContextPlaceholder: 'Trí ghlúin in Éirinn agus i Meiriceá. Mam, deartháir, an chlann ar fad.',
        submit: 'Téigh ar an liosta',
        submitting: 'Á sheoladh...',
        reassurance: 'Ní roinnimid do ríomhphost riamh. Cuirimid chugat é nuair a bhíonn slot ann, agus chuige sin amháin.',
        successTitle: 'Tá tú ar an liosta',
        successBody: 'Beidh teagmháil againn leat chomh luath agus a bhíonn slot againn. Seiceáil do bhosca isteach (agus dramhphost) le haghaidh deimhniú.',
        successNextTitle: 'Cad a tharlaíonn anois',
        successNext1: 'Cuirimid leis an liosta feithimh thú - níl ríomhphost deimhnithe le brú agat.',
        successNext2: 'Nuair a bhíonn slot ann, seolaimid cód cuiridh chuig an ríomhphost seo.',
        successNext3: 'Tapálann tú an cód, cruthaíonn tú do chlann, agus tugann tú cuireadh do na daoine eile.',
        alreadyOnList: 'Tá tú ar an liosta cheana - beidh muid i dteagmháil leat.',
        errorGeneric: 'Theip ar rud éigin. Bain triail eile as, nó scríobh chuig hi@chlann.com.',
        privacyNotice: 'Téann do chuid sonraí chuig Chlann agus stóráiltear iad ar ár bhfreastalaithe san Astráil go dtí go dtugaimid cuireadh duit nó go n-iarrann tú orainn iad a scriosadh.',
        privacyLink: 'Cad a dhéanaimid le do chuid sonraí',
      },
      footer: {
        about: 'Tógtha do theaghlaigh, ní d\'ioncam.',
        // Interpolated from src/config/operator.ts so the entity is stated in
        // one place. {{abn}} is empty until the ABN is supplied, which prints
        // the sentence without an ABN clause rather than a placeholder.
        operator: 'Tá Chlann á oibriú ag {{trading}}, ainm gnó cláraithe le {{person}}{{abn}}.',
        signoff: 'Ar scáth a chéile a mhaireann na daoine.',
        product: {
          heading: 'Táirge',
          features: 'Gnéithe',
          comfort: 'Modh Compoirt',
          invite: 'Iarr cuireadh',
        },
        trust: {
          heading: 'Iontaoibh',
          privacy: 'Príobháideacht',
          faq: 'Ceisteanna coitianta',
          privacyPolicy: 'Polasaí príobháideachta',
          terms: 'Téarmaí úsáide',
        },
        contact: {
          heading: 'Teagmháil',
          email: 'hi@chlann.com',
        },
      },
      trust: {
        sectionTitle: 'Conas a dhéileálann Chlann le do chuid sonraí',
        gdpr: {
          title: 'GDPR ón mbun aníos',
          body: 'Gan fógraí, gan rianú tríú páirtí, gan do shonraí a dhíol. Sin é an dearadh, ní breiseán.',
        },
        honest: {
          title: 'Macánta faoin réamhsheoladh',
          body: 'Tá Chlann i dtástáil dúnta. Ní mhaímid líon úsáideoirí nár tharla fós.',
        },
      },
      irish: {
        eyebrow: 'As Gaeilge ó dhúchas',
        h2: 'Tógtha do theaghlaigh a labhraíonn Gaeilge.',
      },
      faq: {
        eyebrow: 'Ceisteanna coitianta',
        h2: 'Ceisteanna a chuireann teaghlaigh, freagraí macánta.',
        q1: 'An bhfuil sé criptithe i ndáiríre?',
        a1: 'Tá teachtaireachtaí criptithe agus iad á seoladh (TLS) agus criptithe i dtaisce (AES-256-GCM) ar fhreastalaithe a oibrímid san Astráil. Níl criptiú ceann go ceann i bhfeidhm: is againne atá na heochracha, mar sin is féidir linn ábhar teachtaireachta a léamh. Ní dhéanaimid é sin ach nuair a éilíonn an dlí é nó chun gníomhú ar thuairisc inchreidte um shábháilteacht leanaí, trí chonair ar leith nach bhfuil ach ag riarthóirí, agus scríobhtar síos gach uair sula dtarlaíonn sé. Níl taifead uathoibríoch, do-athraithe ar an rochtain sin tógtha go fóill. Deirimid é seo go díreach seachas siombail glas a thaispeáint.',
        q2: 'Cad a tharlaíonn do mo chuid sonraí má dhúnann Chlann?',
        a2: 'Gheobhaidh tú fógra roimh ré agus bealach chun do chuid pictiúr, físeán agus teachtaireachtaí a easpórtáil. Ní dhíolfaí do shonraí mar chuid de dhúnadh - ní hé sin an múnla gnó.',
        q3: 'Conas a chuirfidh mé ina luí ar mo chlann aistriú?',
        a3: 'Roinneann duine amháin nasc cuiridh nó cód QR sa ghrúpa WhatsApp atá agaibh cheana. Tapálann gach duine é agus tá siad istigh - gan uimhir ghutháin, gan leabhar seoltaí. Cabhraíonn Modh Compoirt le baill nach bhfuil chomh cleachta ar an teicneolaíocht.',
        q4: 'An bhfuil sé ar fáil lasmuigh d\'Éirinn?',
        a4: 'Tá. Oibríonn Chlann áit ar bith a bhfuil idirlíon ann. Tógadh é go sonrach do theaghlaigh atá scaipthe thar tíortha - Éire, an Astráil, Meiriceá agus níos faide i gcéin.',
        q5: 'Cad faoi ghaol nach féidir leis an teicneolaíocht a úsáid?',
        a5: 'Cuireann Modh Compoirt spriocanna níos mó agus téacs níos mó ar fáil gan rud ar bith a bhaint amach. Osclaíonn naisc cuiridh an aip agus líonann siad an cód go huathoibríoch - gan aon chód le clóscríobh de láimh.',
        q6: 'Cé mhéad a chosnaíonn sé?',
        a6: 'Tá sraith saor in aisce ann le 1 GB de chuimhní teaghlaigh. Tosaíonn pleananna íoctha ó €4 sa mhí, plean amháin in aghaidh an teaghlaigh, gan teorainn le líon na mball. Tá tástálaithe béite saor in aisce.',
        q7: 'An ndíolann sibh fógraí nó sonraí?',
        a7: 'Ní dhíolaimid. Níl fógraí againn, níl anailísíocht tríú páirtí againn, agus ní dhíolaimid do chuid sonraí. Íocann tú síntiús beag, nó fanann tú ar an tsraith saor in aisce. Sin an múnla gnó ar fad. Déanaimid amharcanna leathanaigh a chomhaireamh le bogearraí anailísíochta a rithimid ar ár bhfreastalaí féin: gan fianáin, gan sonraí pearsanta, agus ní fhágann rud ar bith ár mbonneagar.',
        q8: 'An gá uimhir ghutháin a thabhairt?',
        a8: 'Ní gá. Cláraíonn tú le ríomhphost agus le cuireadh ó dhuine i do chlann. Is féidir uimhir ghutháin a úsáid mar rogha eile chun síniú isteach, ach ní iarrtar ceann ort, agus ní léimid do leabhar seoltaí.',
      },
    },
    dictionary: {
      title: 'Foclóir',
      searchPlaceholder: 'Cuardaigh focal...',
      clear: 'Glan',
      noResults: 'Níor aimsíodh aon torthaí',
      allCategories: 'Gach',
      wordOfTheDay: 'Focal an Lae',
      entries: '{{total}} iontráil',
      browseAll: 'Brabhsáil',
      resultsFound: 'toradh aimsithe',
      categories: {
        family: 'Teaghlach',
        greetings: 'Beannachtaí',
        emotions: 'Mothúcháin',
        time: 'Am',
        food: 'Bia',
        body: 'Corp',
        nature: 'Nádúr',
        home: 'Baile',
        school: 'Scoil',
        travel: 'Taisteal',
        numbers: 'Uimhreacha',
        colors: 'Dathanna',
        common: 'Coitianta',
        conversation: 'Comhrá',
        health: 'Sláinte',
        weather: 'Aimsir',
        sports: 'Spórt',
        work: 'Obair',
        places: 'Áiteanna',
        clothing: 'Éadaí',
        music: 'Ceol',
        culture: 'Cultúr',
      },
    },
  },
};

// English translations
const en = {
  translation: {
    app: {
      name: 'Chlann',
      tagline: 'Your Family, Your Conversations',
    },

    welcome: {
      subtitle: 'Welcome to Chlann',
      description: 'A messaging platform for your family',
    },

    nav: {
      chats: 'Chats',
      calls: 'Calls',
      calendar: 'Calendar',
      family: 'Family',
      photos: 'Photos',
      settings: 'Settings',
    },

    // Register page
    register: {
      createAccount: 'Create your new account',
      passwordHint: 'At least 8 characters',
      haveAccount: 'Already have an account?',
      signupCode: 'Sign-up code',
      signupCodeHint: 'From your invite email',
      elder: {
        enter: 'Sign up one question at a time',
        stepCounter: 'Question {{current}} of {{total}}',
        nameQuestion: 'What is your name?',
        emailQuestion: 'What is your email address?',
        phoneQuestion: 'What is your phone number?',
        passwordQuestion: 'Choose a password',
        codeQuestion: 'Enter your invite code',
      },
    },

    auth: {
      login: 'Log In',
      register: 'Register',
      logout: 'Log Out',
      email: 'Email',
      phone: 'Phone Number',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      twoFactor: 'Two-Factor Authentication',
      enterCode: 'Enter the code',
      sendCode: 'Send Code',
      verifyCode: 'Verify',
      inviteOnlyNotice: 'Chlann is invite-only during beta. Ask a family member already on chlann to send you an invite, or write to ',
      codeSentToEmail: 'Code sent to your email',
      codeSentToPhone: 'Code sent to your phone',
      registrationSuccess: 'Registration successful!',
      welcomeToFamily: "You're welcome to the family.",
      displayNamePlaceholder: 'Sean Murphy',
      inviteCodePlaceholder: 'XXXX-XXXX-XXXX',
      inviteCodeHint: 'Invite code from Macdara',
      inviteCodeFromLink: 'Code locked from invite link',
      privacyNote: "Sign up the old-fashioned way. We don't hand your sign-up to Google, Microsoft, or Apple.",
      // Same stance, worded for signing in. The register copy above reads
      // wrong on the login page, where nobody is signing up.
      privacyNoteLogin: 'Sign in the old-fashioned way. No Google, Microsoft, or Apple account involved.',
      emailPlaceholder: 'name@example.com',
      phonePlaceholder: '+353 ...',
      errors: {
        displayNameRequired: 'Display name is required',
        inviteCodeRequired: 'Invite code is required',
        passwordTooShort: 'Password must be at least 8 characters long',
        passwordMismatch: 'Passwords do not match',
      },
    },

    chat: {
      newMessage: 'New Message',
      typeMessage: 'Type a message...',
      linkPreviewLoading: 'Loading preview',
      linkPreviewRemove: 'Remove preview',
      send: 'Send',
      sending: 'Sending...',
      sent: 'Sent',
      delivered: 'Delivered',
      read: 'Read',
      failed: 'Failed to send',
      typing: '{{name}} is typing...',
      isTyping: 'is typing',
      and: 'and',
      areTyping: 'are typing',
      severalPeopleTyping: 'Several people are typing',
      edited: 'edited',
      deleted: 'This message was deleted',
      reply: 'Reply',
      forward: 'Forward',
      copy: 'Copy',
      delete: 'Delete',
      deleteForEveryone: 'Delete for everyone',
      // New chat translations
      noMessages: 'No messages yet',
      startConversation: 'Start the conversation!',
      today: 'Today',
      yesterday: 'Yesterday',
      encryptedMessage: 'This message was sent before chlann changed how messages are kept. It stays only on the device that first received it.',
      // A run of consecutive pre-cut placeholders, folded into one warm notice.
      legacyRunCollapsed: '{{n}} earlier messages live on the device that first received them.',
      // Failed-send affordance, shown below the bubble on the page background.
      notSent: 'Not sent',
      notSentTapToRetry: 'Not sent. Tap to retry.',
      textMessage: 'Message',
      attachFile: 'Attach file',
      // Irish input features
      irishPhrases: 'Irish Phrases',
      irishInputEnabled: 'Irish Input: a\' → á, Alt+a → á',
      fadaHelp: 'Type vowel + \' for fada (e.g. a\' → á) or use Alt+vowel',
      you: 'You',
      unknown: 'Unknown',
      group: 'Group',
      noConversations: 'No conversations yet',
      startNew: 'Start a New Chat',
      now: 'now',
      members: 'members',
      selectConversation: 'Choose a conversation',
      selectOrStart: 'Pick a chat from the list, or start a new one with your family',
      newConversation: 'New Conversation',
      groupDetails: 'Group Details',
      searchPeople: 'Search people...',
      noUsers: 'Type a name to find family members.',
      noUsersFound: 'No people found.',
      selectAtLeastOne: 'Select at least one person',
      groupName: 'Group Name',
      enterGroupName: 'Enter group name',
      createGroup: 'Create Group',
      startChat: 'Start Chat',
      createFailed: 'Failed to create',
      newGroup: 'New Group',
      // W1-CHAT: list management, receipts, reactions, retry
      pin: 'Pin',
      unpin: 'Unpin',
      pinned: 'Pinned',
      mute: 'Mute',
      unmute: 'Unmute',
      muted: 'Muted',
      muteFor: 'Mute for',
      mute8h: '8 hours',
      mute1d: '1 day',
      mute7d: '1 week',
      muteForever: 'Forever',
      conversationOptions: 'Conversation options',
      moreReactions: 'More reactions',
      reactions: 'Reactions',
      whoReactedHint: 'Hold to see who reacted',
      someone: 'Someone',
      seenBy: 'Seen by',
      tapToRetry: 'Tap to retry',
      newMessages: 'New messages',
      jumpToLatest: 'Jump to latest',
      messageType: {
        text: 'Message',
        image: 'Image',
        video: 'Video',
        voice: 'Voice Note',
        file: 'File',
        location: 'Location',
        poll: 'Poll',
        system: 'System Message',
      },
      // Search
      searchMessages: 'Search messages...',
      searchInConversation: 'Search in this conversation...',
      searchHint: 'Enter at least 2 characters to search',
      directMessage: 'Direct message',
      pressEscToClose: 'Press Esc to close',
      // Bot disclosure
      botLabel: 'Bot',
      botNotEncrypted: 'A bot is in this chat. It can read the messages you send here.',
      addBotConfirmTitle: 'Add a bot to this conversation?',
      addBotConfirmBody: 'Adding {{botName}} lets it read the messages in this conversation. Continue?',
      addBotContinue: 'Continue',
      // UX refresh: labelled header actions + soft unread badge
      search: 'Search',
      info: 'Info',
      unreadMessages: 'Unread messages',
      startNewDescription: 'Start your first conversation with your family',
    },

    // Calm presence buckets - never exact times
    presence: {
      activeNow: 'Active now',
      activeRecently: 'Active recently',
      activeToday: 'Active today',
    },

    calls: {
      voice: 'Voice Call',
      video: 'Video Call',
      incoming: 'Incoming call',
      incomingVoice: 'Incoming voice call',
      incomingVideo: 'Incoming video call',
      outgoing: 'Outgoing call',
      missed: 'Missed call',
      ended: 'Call ended',
      duration: 'Duration: {{duration}}',
      mute: 'Mute',
      unmute: 'Unmute',
      camera: 'Camera',
      cameraOn: 'Turn on camera',
      cameraOff: 'Turn off camera',
      videoOff: 'Off',
      speaker: 'Speaker',
      speakerOn: 'Turn on speaker',
      speakerOff: 'Turn off speaker',
      endCall: 'End Call',
      noHistory: 'No calls yet',
      startFirst: 'Voice and video calls between your family. Open a conversation to start one.',
      startCallCTA: 'Open Chats',
      accept: 'Accept',
      decline: 'Decline',
      calling: 'Calling...',
      initiating: 'Initiating...',
      ringing: 'Ringing...',
      connecting: 'Connecting...',
      callEnded: 'Call ended',
      speaking: 'Speaking',
      flipCamera: 'Flip camera',
      // New-call entry + contact picker
      newCall: 'New call',
      searchContacts: 'Search contacts...',
      noSearchResults: 'No contacts found',
      noConversations: 'No conversations yet',
      startChatFirst: 'Start a chat first to make calls',
      voiceCall: 'Voice call',
      videoCall: 'Video call',
      selectContact: 'Select a contact to start a voice or video call',
      memberCount: '{{count}} members',
      // Start-call errors
      errorMicBlocked: "chlann couldn't access your microphone - check your browser's site permissions.",
      errorNoMic: 'No microphone found. Connect one and try again.',
      errorMicInUse: 'Your microphone is in use by another app. Close it and try again.',
      errorGeneric: "Couldn't start the call. Please try again.",
      // Connection indicator
      connectionQuality: 'Connection quality',
      reconnecting: 'Reconnecting...',
      connectionRestored: 'Connection restored',
      connectionLost: 'Connection lost',
      // In-call controls + missed-call card
      participantMuted: '{{name}} is muted',
      callBack: 'Call back',
      cardMissed: 'Missed call',
      cardDeclined: 'Call not answered',
      cardMessage: 'Message',
      missedCallReply: "Sorry I missed your call - let's talk soon.",
      // Labelled call controls (visible word under each circle)
      end: 'End',
      flip: 'Flip',
      blur: 'Blur',
      reactLabel: 'React',
      react: 'Send a reaction',
    },

    family: {
      create: 'Create Family',
      join: 'Join Family',
      invite: 'Invite',
      members: 'Members',
      admin: 'Admin',
      member: 'Member',
      guest: 'Guest',
      leave: 'Leave',
      inviteCode: 'Invite Code',
      noFamilies: 'No family yet',
      createFirst: 'Create one for your immediate family',
      orJoin: "or join an existing one with an invite code from someone in it",
      emptyHint: "You can do both — the O'Sheas and the McCarthys, for example.",
      familyName: 'Family Name',
      enterFamilyName: 'Enter family name',
      description: 'Description',
      enterDescription: 'Enter description (optional)',
      creating: 'Creating...',
      joining: 'Joining...',
      enterInviteCode: 'Enter invite code',
      regenerateCode: 'Regenerate Code',
      copyCode: 'Copy Code',
      codeCopied: 'Code copied!',
      removeMember: 'Remove Member',
      promoteTo: 'Promote to',
      demoteTo: 'Demote to',
      confirmLeave: 'Are you sure you want to leave this family?',
      confirmRemove: 'Are you sure you want to remove {{name}}?',
      lastAdminWarning: "You can't leave the family as the last admin.",
      youAre: "You're",
      you: 'you',
      memberSince: 'Member since',
      conversations: 'Conversations',
      selectFamily: 'Select a family.',
      inviteFamily: 'Invite family',
      inviteIntro: 'Share this link or QR code with your family so they can join in one tap.',
      inviteLink: 'Invite link',
      copyLink: 'Copy link',
      linkCopied: 'Link copied!',
      shareInvite: 'Share',
      showQr: 'Show QR code',
      hideQr: 'Hide QR code',
      scanToJoin: 'Scan to join',
      inviteShareText: 'Join {{family}} on Chlann',
    },

    photos: {
      gallery: 'Gallery',
      albums: 'Albums',
      allPhotos: 'All Photos',
      upload: 'Upload',
      search: 'Search photos...',
      people: 'People',
      places: 'Places',
      noPhotos: 'Family photos that stay between you',
      uploadFirst: 'Tap + to share your first family photo. Everything you share stays private to your family.',
      uploadFirstCTA: 'Upload Photos',
      noAlbums: 'No albums yet',
      createAlbumFirst: 'Group photos into collections for birthdays, holidays, and more.',
      createAlbumCTA: 'Create Album',
      newAlbum: 'New Album',
      createAlbum: 'Create Album',
      albumName: 'Album Name',
      albumNamePlaceholder: 'Enter album name',
      renameAlbum: 'Rename album',
      deleteAlbum: 'Delete album',
      albumActions: 'Album actions',
      deleteAlbumTitle: 'Delete album',
      deleteAlbumMessage: 'Delete this album? The photos themselves are not deleted.',
      description: 'Description',
      descriptionPlaceholder: 'Optional description...',
      dropOrClick: 'Drop photos here or click to select',
      selectedCount: '{{count}} photos selected',
      loadMore: 'Load more',
      select: 'Select',
      selectionCount: '{{count}} selected',
      simpleMode: 'Simple view',
      pin: 'Pin',
      unpin: 'Unpin',
      pinned: 'Pinned',
      hide: 'Hide',
      moveUp: 'Move up',
      moveDown: 'Move down',
      openPhoto: 'Open photo from {{date}}',
      allHidden: 'All photos are hidden',
      allHiddenDesc: 'You have hidden every photo in this view.',
      showHidden: 'Show hidden photos',
      showHiddenCount: 'Show {{count}} hidden',
      addToAlbum: 'Add to album',
      chooseAlbum: 'Choose an album',
      noAlbumsToAdd: 'Create an album first to add photos.',
      download: 'Download',
      setAsCover: 'Set as cover',
      showAllPhotos: 'Show all photos',
      deletePhotosTitle: 'Delete photos',
      deletePhotosMessage_one: 'Delete this photo? This cannot be undone.',
      deletePhotosMessage_other: 'Delete {{count}} photos? This cannot be undone.',
      searchComingSoon: 'Photo search is coming after launch.',
      searchComingSoonBody: 'For v1 you can browse by album. Semantic search and face grouping are on the post-launch roadmap.',
      video: 'Video',
      regenerateRecap: 'Show another memory',
      hideRecap: 'Hide on this day',
      period: {
        today: 'Today',
        yesterday: 'Yesterday',
        thisWeek: 'Earlier this week',
        thisMonth: 'Earlier this month',
      },
    },

    // Memory Session (shared slideshow during calls)
    memory: {
      sharePhotos: 'Share Photos',
      selectAlbum: 'Share Photos',
      selectAlbumDescription: 'Choose an album to view together',
      noAlbums: 'No Albums',
      noAlbumsDescription: 'Create an album first to share photos during calls',
      photoCount: '{{count}} photos',
      playRecap: 'Play recap montage',
      playRecapDescription: 'Look back through everything you have shared',
      emptyAlbum: 'This album has no photos to show yet. Add a few photos, then try again.',
      emptyRecap: 'There are no shared photos to recap yet. Share some photos in this chat, then try again.',
      emptyDate: 'No photos were shared on this day in earlier years yet.',
      emptySelection: 'None of the chosen photos could be shown.',
      bothCanControl: 'Both participants can control the slideshow',
      noPhotos: 'No photos',
      previous: 'Previous photo',
      next: 'Next photo',
      play: 'Play slideshow',
      pause: 'Pause slideshow',
      endSession: 'End memory session',
      photo: 'Photo',
      photoLoadError: 'Could not load photo',
      previousPhoto: 'Previous photo',
      nextPhoto: 'Next photo',
      sitBackAndEnjoy: 'Sit back & enjoy',
      autoPlayHint: 'Photos will play automatically',
      onThisDay: 'On this day',
      tapToLookTogether: 'Tap a memory to look back together',
      lookTogether: 'Look back together',
      dailyPromptTitle: 'On this day',
      dailyPromptBody: 'Your family shared moments on this day.',
      dailyPromptBodyNamed: 'You and {{name}} shared moments on this day.',
      notNow: 'Not now',
    },

    calendar: {
      title: 'Calendar',
      newEvent: 'New Event',
      editEvent: 'Edit Event',
      create: 'Create',
      noEvents: 'No events for this day',
      noEventsHint: 'Tap + New Event to add a birthday, gathering, or reminder.',
      today: 'Today',
      allDay: 'All day',
      location: 'Location',
      locationPlaceholder: 'Add a location...',
      description: 'Description',
      descriptionPlaceholder: 'Add a description...',
      titlePlaceholder: 'Event name',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      color: 'Color',
      reminder: 'Reminder',
      reminderNone: 'No reminder',
      reminderMinutes: '{{count}} minutes before',
      reminderHours: '{{count}} hours before',
      reminderDays: '{{count}} days before',
      recurrence: {
        label: 'Recurrence',
        none: 'No recurrence',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
        endDate: 'Recurrence end date',
      },
      rsvp: {
        accept: 'Accept',
        decline: 'Decline',
        maybe: 'Maybe',
      },
      yourRsvp: 'Your RSVP',
      attendee: 'attendee',
      attendees: 'attendees',
      createdBy: 'Created by {{name}}',
      deleteConfirmTitle: 'Delete Event',
      deleteConfirmMessage: 'Are you sure you want to delete this event? This cannot be undone.',
      days: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
      months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December',
      },
    },

    wizard: {
      welcome: {
        title: 'Welcome to Chlann',
        subtitle: 'A private messaging platform for your family. Encrypted, secure, and built for you.',
        getStarted: 'Get Started',
        featureChat: 'Messaging',
        featurePhotos: 'Photos',
        featureCalls: 'Calls',
        featurePrivacy: 'Encrypted messages',
      },
      family: {
        title: 'Set Up Your Family',
        subtitle: 'Create a new family or join one with an invite code.',
        createNew: 'Create Family',
        createDesc: 'Start a new group for your family',
        joinExisting: 'Join a Family',
        joinDesc: 'Enter an invite code from a family member',
        familyName: 'Family Name',
        familyNamePlaceholder: "e.g. The O'Sheas",
        inviteCode: 'Invite Code',
        inviteCodePlaceholder: 'Enter invite code',
        skip: 'Do this later',
      },
      comfort: {
        title: 'Make text bigger?',
        subtitle: 'Comfort Mode enlarges text and buttons so Chlann is easier to read and tap. You can change this any time in Settings.',
        sample: 'This is how your text will look.',
        enable: 'Turn on Comfort Mode',
        keepStandard: 'Keep the standard size',
      },
      complete: {
        title: "You're all set!",
        subtitleWithFamily: 'Your family is set up. Start chatting!',
        subtitleWithoutFamily: 'You can create or join a family anytime from Settings.',
        startChatting: 'Start Chatting',
      },
      progress: {
        step: 'Step {{current}} of {{total}}',
      },
    },

    settings: {
      profile: 'Profile',
      displayName: 'Display Name',
      privacy: 'Privacy',
      notifications: 'Notifications',
      language: 'Language',
      theme: 'Theme',
      darkMode: 'Dark Mode',
      darkModeDesc: 'A darker look, easier on the eyes at night',
      appearance: 'Appearance',
      themeSystem: 'System',
      themeLight: 'Light',
      themeDark: 'Dark',
      accessibility: 'Accessibility',
      accessibilityMode: 'Accessibility Mode',
      about: 'About',
      version: 'Version',
      display: 'Display',
      textSize: 'Text size',
      textSizeDesc: 'Make all text larger or smaller',
      textSizeStandard: 'Standard',
      textSizeLarge: 'Large',
      textSizeLarger: 'Larger',
      highContrast: 'High contrast',
      highContrastDesc: 'Stronger text and edges for easier reading',
      dyslexiaFont: 'Dyslexia-friendly font',
      dyslexiaFontDesc: 'Easier-to-read letter shapes for dyslexia',
      fullscreen: 'Fullscreen Mode',
      fullscreenDesc: 'Hide device status bar for complete immersion',
      fullscreenNotSupported: 'Your browser does not support fullscreen mode',
      changePhoto: 'Change Photo',
      removePhoto: 'Remove Photo',
      uploadAvatar: 'Upload Profile Photo',
      invalidImageType: 'Invalid image type. Use JPEG, PNG, GIF, or WebP.',
      imageTooLarge: 'Image is too large. Maximum 5MB.',
      comfort: 'Make chlann easier to see',
      comfortDesc: 'Text size, contrast and motion. These apply everywhere in chlann and are always free.',
      textSizeUseSystem: 'Use system text size',
      textSizeUseSystemDesc: 'Follow the text size set on your device',
      reduceMotion: 'Reduce motion',
      reduceMotionDesc: 'Fewer animations and movement',
      reset: 'Reset',
      previewLabel: 'Preview',
      previewHeading: 'Family chat',
      previewMessage1: 'Are you coming for dinner on Sunday?',
      previewMessage2: 'We will be there. Can we bring anything?',
      previewHint: 'Move the slider to set your text size. It changes text everywhere in chlann.',
      // Instant-apply settings: scoped Save + saved/failed feedback
      saveProfile: 'Save profile',
      changesSaved: 'Saved',
      saveFailed: 'Could not save that change. Please try again.',
    },

    privacy: {
      onlineStatus: 'Show online status',
      lastSeen: 'Show last seen',
      readReceipts: 'Send read receipts',
      typingIndicator: 'Show typing indicator',
    },

    notifications: {
      title: 'Notifications',
      enablePush: 'Enable push notifications',
      enableInApp: 'Enable in-app notifications',
      muteAll: 'Mute all notifications',
      notifyFor: 'Notify me for:',
      messages: 'Messages',
      calls: 'Calls',
      familyUpdates: 'Family updates',
      photoUploads: 'Photo uploads',
      markAllRead: 'Mark all as read',
      noNotifications: 'No notifications',
      viewAll: 'View all',
      newMessage: 'New message from {{sender}}',
      incomingCall: 'Incoming call from {{caller}}',
      familyJoined: '{{member}} joined the family',
      newPhotos: '{{uploader}} uploaded new photos',
      deleteConfirm: 'Are you sure you want to delete this notification?',
      delete: 'Delete notification',
      empty: 'No notifications yet',
      settings: 'Notification settings',
    },

    common: {
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      done: 'Done',
      edit: 'Edit',
      delete: 'Delete',
      create: 'Create',
      close: 'Close',
      confirm: 'Confirm',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      retry: 'Retry',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      or: 'or',
      back: 'Back',
      next: 'Next',
      search: 'Search',
      noResults: 'No results found',
      menu: 'Menu',
    },

    time: {
      justNow: 'just now',
      minuteAgo: 'a minute ago',
      minutesAgo: '{{count}} minutes ago',
      hourAgo: 'an hour ago',
      hoursAgo: '{{count}} hours ago',
      yesterday: 'yesterday',
      daysAgo: '{{count}} days ago',
    },

    // Landing Page (marketing rebuild - phase 4b)
    landing: {
      nav: {
        privacy: 'Privacy',
        app: 'The app',
        invites: 'Invites',
        pricing: 'Pricing',
        requestInvite: 'Request invite',
        comfort: 'Comfort',
      },
      hero: {
        h1En: 'A private room for the whole family.',
        h1Ga: 'Seomra príobháideach don chlann go léir.',
        primary: 'Request an invite',
        proof: {
          encrypted: 'Private, encrypted messages',
          noAds: 'No ads, no third-party tracking',
          allGenerations: 'For every generation',
        },
        imageAlt: 'Three generations around a kitchen table, tea being poured, a phone lying flat on the table between them.',
      },
      thread: {
        title: 'An Teaghlach',
        sub: '9 members · active now',
        encrypted: 'Encrypted',
        momName: 'Máire (Mam)',
        momMsg: "Dinner at 7 on Sunday. Nana's bringing the apple tart.",
        myReply: "Grand, I'll be there.",
        nanaName: 'Nana',
        voiceDuration: '0:42',
        previewLabel: 'Thread preview',
      },
      privacy: {
        eyebrow: 'Privacy, with specifics',
        h2: 'Your messages are encrypted in transit and at rest on servers we operate in Australia. Never sold, never scanned for ads.',
        intro: 'Here is what is protected, and exactly what we can and cannot see, in plain terms.',
        claim1: {
          title: 'Encrypted in transit and at rest',
          body: 'Messages travel over TLS and are stored encrypted at rest on servers we operate in Australia. We do not run ads, third-party trackers, or any content scanning. We can access message content only where legally compelled, or to act on a credible child-safety report.',
          step1: 'Encrypted in transit (TLS) and at rest on our servers',
          step2: 'No ads, no third-party trackers, no content scanning',
          step3: 'Access only on a valid legal order or a child-safety report',
        },
        claim2: {
          title: 'You choose the resolution',
          body: 'Every photo goes at Original, Standard or Quick, and you pick per send. The file you send is the file we store, at the size you sent it.',
          step1: 'Photos: Original / Standard / Quick — your choice per send',
          step3: 'What you send is what we keep',
        },
        claim3: {
          title: 'No ads, no tracking',
          body: "No ads. No third-party analytics. We do not scan your messages and we do not sell your data. You pay us a small subscription, or you don't. That's the whole business model.",
          step1: 'Generous free tier: 1 GB of family memory',
          step2: 'Paid plans from €4/month',
          step3: 'No users-as-product tier',
        },
        cipher: {
          heading: 'What a message passes through',
          serverLabel: 'Stored on our servers',
          deviceLabel: 'Delivered in the family room',
          message: 'Oíche mhaith, a Nana ❤️',
          note: 'An illustration of the path a message takes. Exactly what we can and cannot see is spelled out below.',
        },
      },
      product: {
        h2: 'Messaging, calendar, photos. One room for the family.',
        thread: {
          title: 'Family thread',
          body: 'Group messaging, replies, voice notes, reactions. Everyone on one thread.',
          msg1Name: 'Nana',
          msg1: 'Conas atá sibh?',
          msg2: 'Go maith a Nana!',
        },
        calendar: {
          title: 'Shared calendar',
          body: 'Birthdays, a christening, the trip home. Everyone RSVPs, each person sets their own reminder, and the yearly ones come back on their own.',
          monthLabel: 'May',
          year: '2026',
          event1Month: 'MAY',
          event1Title: "Nana's 80th",
          event1Chip: 'Going 6',
          event2Month: 'MAY',
          event2Title: 'Hurling match',
          event2Chip: 'Pending 2',
          event3Month: 'JUN',
          event3Title: "Sinéad's exam",
          event3Chip: 'Reminder',
          alt: 'A tablet on the kitchen counter showing the family calendar while the school-morning happens around it.',
        },
        photos: {
          title: 'Family photos',
          body: 'Albums by month or by event.',
          nanaLabel: 'Nana',
          alt: 'A grandmother and grandchildren looking at family photos on a phone.',
        },
        groupCall: {
          title: 'The whole family',
          body: 'Three generations, four homes, one call. No scheduling, no setup - Friday at six, just hop in.',
          alt: "Over Nana's shoulder: a tablet on her kitchen table showing a four-up family video call.",
        },
        splitCall: {
          title: 'Face to face',
          body: "Call Granny. Call your mum. No scheduling, no camera setup - just 'hi, how are you?' in either language.",
          alt: 'A split-screen video call between a young woman and her grandfather.',
        },
      },
      comfort: {
        eyebrow: 'Multi-generational, by design',
        h2: 'Same interface, two densities.',
        intro: 'Comfort Mode gives bigger targets and larger type, with every feature still where it was. A grandparent and a teenager use the same app.',
        standardTag: 'Standard · 40px targets',
        comfortTag: 'Comfort Mode · 56px targets',
        cardTitle: 'New message from Máire',
        cardBody: "Dinner at 7 on Sunday. Nana's bringing the tart.",
        reply: 'Reply',
        later: 'Later',
        toggleOn: 'Turn on Comfort Mode',
        toggleOff: 'Turn off Comfort Mode',
      },
      invite: {
        eyebrow: 'Invite-only, on purpose',
        h2: 'No public sign-up. You join a family, not a network.',
        intro: "Someone in your family shares a single invite link or QR code with you - tap it and you are in. No phone number harvested, no address book read, no discoverability.",
        testingFootnote: 'During closed testing, codes are issued directly by Chlann rather than by other family members. Join the waitlist to request one.',
        step1: {
          title: 'Get your link',
          body: 'A family member creates an invite link and QR code from the Family page.',
        },
        step2: {
          title: 'Share it',
          body: 'Tap Share to drop it into your existing WhatsApp group, or show the QR code to scan.',
        },
        step3: {
          title: 'Tap to join',
          body: 'The link opens Chlann and fills in the code for you. Nothing to type by hand.',
        },
        step4: {
          title: 'Offer Comfort Mode',
          body: "The app asks on first launch. You don't set it for anyone else - each person chooses.",
        },
      },
      pricing: {
        eyebrow: 'Pricing',
        h2: 'Plans that grow with your family.',
        intro: 'Generous free tier. Paid plans from €4/month. One plan covers the whole family, with no cap on members; group calls on the free tier carry four at a time.',
        testingNotice: 'Prices shown for when Chlann exits closed testing. Beta testers are free.',
        toggle: {
          monthly: 'Monthly',
          annual: 'Annual',
          saveLabel: 'save 2 months',
        },
        popular: 'Most popular',
        perMonth: '/mo',
        perYear: '/yr',
        ctaFree: 'Start free',
        ctaPaid: 'Choose',
        free: 'Free',
        tiers: {
          caint: {
            name: 'Caint',
            sub: 'Free',
            tagline: 'Caint is talk. The room, the calls, the calendar.',
            storage: '1 GB',
            f1: 'Chat, calendar, photos, calls',
            f2: 'Group calls up to 4 people',
            f3: 'Email support — 1 business week',
          },
          cuairt: {
            name: 'Cuairt',
            sub: 'Lite',
            tagline: 'Cuairt is a visit. A year of photos at full size.',
            storage: '25 GB',
            f1: 'Photo quality choice: Original / Standard / Quick',
            f2: 'Shared albums, by month or by event',
            f3: 'Email support — 1 business day',
          },
          teach: {
            name: 'Teach',
            sub: 'Family',
            tagline: 'Teach is a house. Room for the whole household.',
            storage: '100 GB',
            f1: 'Everything in Cuairt',
            f2: 'Storage for years of family digital life',
            f3: 'Email support — 1 business day',
          },
          duchas: {
            name: 'Dúchas',
            sub: 'Heritage',
            tagline: 'Dúchas is where you come from. Five times the room of Teach.',
            storage: '500 GB',
            f1: 'Everything in Teach',
            f2: '500 GB - five times the storage of Teach',
            f3: 'Priority support — 1 business day',
          },
          cartlann: {
            name: 'Cartlann',
            sub: 'Archive',
            tagline: 'Cartlann is an archive. Twice the room of Dúchas.',
            storage: '1 TB',
            f1: 'Everything in Dúchas',
            f2: '1 TB - twice the storage of Dúchas',
          },
        },
      },
      closedTesting: {
        banner: 'Chlann is currently in closed testing. Join the waitlist for an invite.',
        dismiss: 'Dismiss notice',
      },
      waitlist: {
        title: 'Join the waitlist',
        intro: "Tell us a bit about your family. We'll send you a code as soon as a slot opens.",
        emailLabel: 'Email',
        emailPlaceholder: 'you@example.com',
        nameLabel: 'Your name',
        namePlaceholder: 'Mary Smith',
        familyContextLabel: 'Tell us about your family (optional)',
        familyContextPlaceholder: 'Three generations across Ireland and the US. Mam, my brother, and the cousins.',
        submit: 'Join the waitlist',
        submitting: 'Sending...',
        reassurance: 'We never share your email. We use it to send your invite when a slot opens, and for nothing else.',
        successTitle: "You're on the list",
        successBody: "We'll be in touch as soon as we have a slot. Check your inbox (and spam) for a confirmation.",
        successNextTitle: 'What happens next',
        successNext1: "We add you to the waitlist - there's no confirmation email to click.",
        successNext2: 'When a slot opens, we email an invite code to this address.',
        successNext3: 'You tap the code, set up your family, and invite the rest of them.',
        alreadyOnList: "You're already on the list — we'll be in touch.",
        errorGeneric: 'Something went wrong. Try again, or write to hi@chlann.com.',
        privacyNotice: 'Your details go to Chlann and are stored on our servers in Australia until we invite you or you ask us to delete them.',
        privacyLink: 'What we do with your data',
      },
      footer: {
        about: 'Built for families living in more than one house.',
        // Interpolated from src/config/operator.ts so the entity is stated in
        // one place. {{abn}} is empty until the ABN is supplied, which prints
        // the sentence without an ABN clause rather than a placeholder.
        operator: 'Chlann is operated by {{trading}}, a registered business name of {{person}}{{abn}}.',
        // Irish proverb, left untranslated on purpose: "people live in one
        // another's shelter". Rendered lang="ga" in both locales.
        signoff: 'Ar scáth a chéile a mhaireann na daoine.',
        product: {
          heading: 'Product',
          features: 'Features',
          comfort: 'Comfort Mode',
          invite: 'Request an invite',
        },
        trust: {
          heading: 'Trust',
          privacy: 'Privacy',
          faq: 'FAQ',
          privacyPolicy: 'Privacy policy',
          terms: 'Terms of use',
        },
        contact: {
          heading: 'Contact',
          email: 'hi@chlann.com',
        },
      },
      trust: {
        sectionTitle: 'How Chlann handles your data',
        gdpr: {
          title: 'Paid for by subscriptions',
          body: 'You pay a small subscription, or you stay on the free tier. No ads, no third-party trackers, and your data is never for sale.',
        },
        honest: {
          title: 'Honest about pre-launch',
          body: 'Chlann is in closed testing. We do not claim user numbers that have not happened yet.',
        },
      },
      irish: {
        eyebrow: 'Bilingual by design',
        h2: 'Built for Irish-speaking families.',
      },
      faq: {
        eyebrow: 'Frequently asked questions',
        h2: 'The questions families ask, answered honestly.',
        q1: 'Is it really encrypted?',
        a1: 'Messages are encrypted in transit (TLS) and encrypted at rest (AES-256-GCM) on servers we operate in Australia. It is not end-to-end encrypted: we hold the keys, so we can read message content. We do that only where legally compelled or to act on a credible child-safety report, through a separate admin-only path, and every instance is written down before it happens. An automatic, tamper-evident record of that access is not built yet. We tell you this plainly rather than showing a padlock icon.',
        q2: 'What happens to my data if Chlann closes?',
        a2: 'You would get notice in advance and a way to export your photos, videos, and messages. Your data would not be sold off as part of a shutdown - that is not the business model.',
        q3: 'How do I get my family to switch?',
        a3: 'One person shares an invite link or QR code in your existing WhatsApp group. Everyone taps it and they are in - no phone number, no address book. Comfort Mode helps less tech-confident relatives find their feet.',
        q4: 'Is it available outside Ireland?',
        a4: 'Yes. Chlann works anywhere with an internet connection. It was built specifically for families split across countries - Ireland, Australia, the US, and further afield.',
        q5: 'What if a relative cannot use tech?',
        a5: 'Comfort Mode gives bigger targets and larger type without simplifying anything away. Invite links open the app and fill in the code automatically, so there is nothing to type by hand.',
        q6: 'How much does it cost?',
        a6: 'There is a free tier with 1 GB of family memory. Paid plans start from €4/month, one plan per family, with no limit on the number of members. Beta testers are free.',
        q7: 'Do you sell ads or data?',
        a7: 'No. There are no ads, no third-party analytics, and we do not sell your data. You pay a small subscription, or you stay on the free tier. That is the whole business model. We do count page views, using analytics software we run on our own server: no cookies, no personal data, and nothing leaves our infrastructure.',
        q8: 'Do I need to give a phone number?',
        a8: 'No. You sign up with an email and an invite from someone in your family. A phone number works as an alternative sign-in, but nothing asks for one, and we do not read your address book.',
      },
    },
    dictionary: {
      title: 'Dictionary',
      searchPlaceholder: 'Search for a word...',
      clear: 'Clear',
      noResults: 'No results found',
      allCategories: 'All',
      wordOfTheDay: 'Word of the Day',
      entries: '{{total}} entries',
      browseAll: 'Browse',
      resultsFound: 'results found',
      categories: {
        family: 'Family',
        greetings: 'Greetings',
        emotions: 'Emotions',
        time: 'Time',
        food: 'Food',
        body: 'Body',
        nature: 'Nature',
        home: 'Home',
        school: 'School',
        travel: 'Travel',
        numbers: 'Numbers',
        colors: 'Colors',
        common: 'Common',
        conversation: 'Conversation',
        health: 'Health',
        weather: 'Weather',
        sports: 'Sports',
        work: 'Work',
        places: 'Places',
        clothing: 'Clothing',
        music: 'Music',
        culture: 'Culture',
      },
    },
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ga,
      en,
    },
    supportedLngs: ['ga', 'en'],
    // Irish stays the brand anchor, but English speakers no longer land on
    // an all-Irish page on first visit — the detector reads (in order):
    // ?lng=, cookie 'i18nextLng', localStorage 'i18nextLng', navigator.language,
    // <html lang>. Non-English, non-Irish browsers still see English (not Irish)
    // because most English-preferring visitors would bounce from an Irish-only page.
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true, // 'en-US' → 'en', 'ga-IE' → 'ga'
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18nextLng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

// Sync html lang attribute with selected language
document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// ===========================================================================
// i18n BACKFILL (Vikunja #1026)
// ===========================================================================
// These keys were only ever supplied inline as t('key', 'English default'), so
// they were absent from BOTH locale bundles above and the key-hygiene lint
// could not catch a typo'd key. Registered here so both bundles resolve them.
//
// The values are the inline defaults the calls already rendered, so behaviour
// is unchanged. For English-text values the `ga` entry is therefore an ENGLISH
// PLACEHOLDER pending the native-speaker pass (Vikunja #1026) - Chlann's Irish
// is human-written, never machine-translated, so we do not ship guessed
// Gaeilge; the reviewer replaces these with real translations. (Entries whose
// inline default is already Irish, e.g. dictionary.*, land correct in `ga`.)
const i18nBackfill: Record<string, string> = {
  "calendar.nextMonth": "Next month",
  "calendar.previousMonth": "Previous month",
  "calendar.selectFamily": "Select family",
  "calls.blurOff": "Turn off background blur",
  "calls.blurOn": "Blur background",
  "calls.incomingCall": "Incoming call",
  "chat.addCaption": "Add a caption...",
  "chat.addMember": "Add",
  "chat.addReaction": "Add reaction",
  "chat.admin": "Admin",
  "chat.announcementLocked": "Only admins can post in this announcement group",
  "chat.announcementMode": "Announcement mode",
  "chat.announcementModeHint": "Only admins can send messages",
  "chat.announcementOnAdmin": "Announcement mode - only you and other admins can post",
  "chat.announcementOnMember": "Announcement mode - only admins can post here",
  "chat.cancelRecording": "Cancel recording",
  "chat.celebration": "A wee celebration",
  "chat.chooseFamilyPlaceholder": "Choose a family...",
  "chat.conversationInfo": "Conversation info",
  "chat.deleteConfirm": "Delete this message?",
  "chat.disappearing1d": "1 day",
  "chat.disappearing1h": "1 hour",
  "chat.disappearing7d": "7 days",
  "chat.disappearingMessages": "Disappearing messages",
  "chat.disappearingMessagesHint": "New messages vanish after the chosen time",
  "chat.disappearingOff": "Off",
  "chat.disappearingOn": "Messages disappear after",
  "chat.discardVoiceNote": "Discard voice note",
  "chat.dropToAttach": "Drop files to attach",
  "chat.edit": "Edit",
  "chat.editMessage": "Edit message",
  "chat.editMessagePlaceholder": "Edit your message...",
  "chat.forwardTo": "Forward to",
  "chat.forwarded": "Forwarded",
  "chat.groupInfo": "Group info",
  "chat.groupSettings": "Group settings",
  "chat.heritageStickers": "Heritage stickers",
  "chat.leaveFailed": "Could not leave the conversation",
  "chat.leaveGroup": "Leave group",
  "chat.mentionMember": "Mention a member",
  "chat.messageDeleted": "This message was deleted",
  "chat.messageOptions": "Message options",
  "chat.noFamilies": "You are not a member of any family",
  "chat.reRecord": "Re-record",
  "chat.recordVoiceMessage": "Record voice message",
  "chat.removeAttachment": "Remove attachment",
  "chat.removeMember": "Remove member",
  "chat.rename": "Rename",
  "chat.reviewVoiceNote": "Review your voice note",
  "chat.selectFamily": "Select family",
  "chat.selectThread": "Select a chat",
  "chat.shareToGallery": "Share to Gallery",
  "chat.shareToGalleryDescription": "This photo will be visible to all members of the selected family.",
  "chat.shared.docs": "Docs",
  "chat.shared.links": "Links",
  "chat.shared.loadMore": "Load more",
  "chat.shared.media": "Media",
  "chat.shared.noDocs": "No documents shared yet",
  "chat.shared.noLinks": "No links shared yet",
  "chat.shared.noMedia": "No media shared yet",
  "chat.shared.unknownSender": "Unknown",
  "chat.sharedSuccessfully": "Shared to gallery!",
  "chat.sharingToFamily": "Sharing to",
  "chat.showConversations": "Show conversations",
  "chat.status.delivered": "Delivered",
  "chat.status.failed": "Failed to send",
  "chat.status.read": "Read",
  "chat.status.sending": "Sending...",
  "chat.status.sent": "Sent",
  "chat.sticker": "Sticker",
  "chat.stickers": "Stickers",
  "chat.stopRecording": "Stop and review",
  "chat.transcript": "Transcript",
  "chat.transcriptPlaceholder": "Transcript (you can edit it before sending)",
  "chat.transcriptUnavailable": "Live transcript is not available in this browser",
  "chat.typeToSearch": "Type a name to search",
  "common.creating": "Creating...",
  "common.daysAgo": "{{count}} days ago",
  "common.device": "device",
  "common.devices": "devices",
  "common.dismiss": "Dismiss",
  "common.hoursAgo": "{{count}} hr ago",
  "common.justNow": "Just now",
  "common.minutesAgo": "{{count}} min ago",
  "common.sharing": "Sharing...",
  "common.yesterday": "Yesterday",
  "dictionary.drawerHint": "Clóscríobh focal le cuardach a dhéanamh",
  "dictionary.fadaHint": "Clóscríobh a' le haghaidh á",
  "dictionary.lookupHint": "Foclóir — cliceáil le focal a chuardach",
  "dictionary.open": "Foclóir",
  "dictionary.results": "Torthaí",
  "dictionary.source": "Foinse: LSG WordNet · Teanglann.ie · ODbL",
  "dictionary.tryAgain": "Bain triail eile as ar ball",
  "encryption.e2e": "E2E",
  "family.memberActions": "Member actions",
  "landing.nav.closeMenu": "Close menu",
  "landing.nav.openMenu": "Open menu",
  "landing.nav.signIn": "Sign in",
  "memory.isDriving": "{{name}} is driving",
  "memory.takeControl": "Take control",
  "memory.youAreDriving": "You are driving",
  "nav.dictionary": "Foclóir",
  "photos.compressing": "Compressing",
  "photos.compressionNote": "Images will be compressed to save data",
  "photos.nextPhoto": "Next photo",
  "photos.previousPhoto": "Previous photo",
  "photos.saved": "Saved",
  "photos.selectPhotos": "Select photos to upload",
  "photos.uploading": "Uploading",
  "settings.deviceListCapNote": "Showing your most recently active devices ({{shown}} of {{total}})",
  "settings.deviceSecurityInfo": "Removing a device signs it out and revokes its access to your account. Your message history stays safe and remains readable on your other devices.",
  "settings.linkedDevices": "Linked Devices",
  "settings.linkedDevicesDesc": "Manage devices that can access your account",
  "settings.removeDevice": "Remove device",
  "settings.thisDevice": "This device",
  "settings.unknownDevice": "Unknown Device",
  "wizard.family.chooseDesc": "Create a new family or join one with an invite code from someone else.",
  "wizard.family.chooseTitle": "Get started with a family",
  "wizard.family.createConfirm": "Create Family",
  "wizard.family.createCta": "Create a Family",
  "wizard.family.createTitle": "Name your family",
  "wizard.family.joinCta": "Join Existing Family",
  "wizard.family.nameLabel": "Family name",
  "wizard.family.namePlaceholder": "The Murphys"
};

// Expand flat dotted keys ('chat.status.read') into the nested shape i18next
// stores, then deep-merge into each bundle without overwriting any existing
// (real) translation.
function nestI18nBackfill(flat: Record<string, string>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [dotted, value] of Object.entries(flat)) {
    const parts = dotted.split('.');
    let node = out;
    for (let i = 0; i < parts.length - 1; i++) {
      if (typeof node[parts[i]] !== 'object' || node[parts[i]] === null) {
        node[parts[i]] = {};
      }
      node = node[parts[i]] as Record<string, unknown>;
    }
    node[parts[parts.length - 1]] = value;
  }
  return out;
}

const i18nBackfillNested = nestI18nBackfill(i18nBackfill);
// deep = true (merge nested), overwrite = false (real translations win).
i18n.addResourceBundle('en', 'translation', i18nBackfillNested, true, false);
i18n.addResourceBundle('ga', 'translation', i18nBackfillNested, true, false);


export default i18n;
